import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/lib/auth";

const API_URL = process.env.REACT_APP_BACKEND_URL;

// Google OAuth landing route: /auth/google?code=...&state=...
export default function GoogleCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser, refresh } = useAuth();
  const hasProcessed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    (async () => {
      const params = new URLSearchParams(location.search);
      const code = params.get("code");
      const state = params.get("state");
      const oauthError = params.get("error");
      if (oauthError || !code || !state) {
        setError(oauthError ? `Google sign-in was cancelled or failed (${oauthError})` : "Missing authorization code");
        return;
      }
      try {
        const res = await fetch(`${API_URL}/api/auth/google/exchange`, {
          method: "POST",
          credentials: "include",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ code, state }),
        });
        if (!res.ok) {
          const j = await res.json().catch(() => ({}));
          throw new Error(j.detail || "Login failed");
        }
        const u = await res.json();
        setUser({ user_id: u.user_id, email: u.email, name: u.name, picture: u.picture, is_admin: u.is_admin });
        await refresh();
        let returnTo = "/";
        try { returnTo = sessionStorage.getItem("bb_return_to") || "/"; sessionStorage.removeItem("bb_return_to"); } catch {}
        navigate(returnTo, { replace: true });
      } catch (e) {
        setError(e.message || "Login failed");
      }
    })();
  }, []); // eslint-disable-line

  return (
    <div className="min-h-screen bg-[#0D0F12] text-white flex flex-col items-center justify-center" data-testid="google-callback">
      {error ? (
        <>
          <div className="text-red-400 text-sm" data-testid="google-callback-error">{error}</div>
          <button onClick={() => navigate("/")} className="mt-4 px-5 py-2 rounded-full border border-white/20 text-sm">Back to home</button>
        </>
      ) : (
        <>
          <Loader2 className="w-6 h-6 text-[#00cccc] animate-spin" />
          <div className="mt-3 text-sm text-zinc-400">Signing you in…</div>
        </>
      )}
    </div>
  );
}
